/**
 * @desc 重推订单到OmsFlow
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(params: API.business.customerOrder.pushToOmsFlow.Params, options?: any) {
  return updateResponse(
    http(URL + `/customerOrder/pushToOmsFlow`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
